attachEvent('.embeded-video .embeded-video__poster', 'click', (ev) => {
  const parent = ev.target.closest('.embeded-video');
  const video = parent.querySelector(windowWidth() < breakpointMd ? '.mobile' : '.desktop');
  parent.classList.add('is-playing');
  video.play();
});
